/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

import { NavbarBrand, Navbar, Container } from "reactstrap";

import LanguageSelect from "components/LanguageSelect/LanguageSelect";
import { useSelector } from "react-redux";

const PublicNavbar = () => {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  }, []);

  return (
    <Navbar
      className={classnames("fixed-top", navbarColor)}
      color-on-scroll="300"
      expand="lg"
    >
      <Container fluid className="d-flex align-items-center flex-nowrap px-3">
        <div className="navbar-translate flex-grow-1 min-w-0 mr-2">
          <NavbarBrand
            data-placement="bottom"
            to="/index"
            target="_blank"
            title="Coded by Creative Tim"
            tag={Link}
            className="mb-0 text-wrap public-navbar-brand"
          >
            Систем за електронски информации за котирани акционерски друштва
          </NavbarBrand>
        </div>

        <div className="d-flex align-items-center flex-shrink-0">
          <LanguageSelect />
        </div>
      </Container>
    </Navbar>
  );
};

export default PublicNavbar;
